import { render, staticRenderFns } from "./HelpMain.vue?vue&type=template&id=61a2da64&scoped=true"
import script from "./HelpMain.vue?vue&type=script&lang=js"
export * from "./HelpMain.vue?vue&type=script&lang=js"
import style0 from "./HelpMain.vue?vue&type=style&index=0&id=61a2da64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a2da64",
  null
  
)

export default component.exports